export default "__VITE_ASSET__5fc9bb92__"